<template xmlns="http://www.w3.org/1999/html">
    <td :class="[date.index == actualDate ? 'curweek' : '']">
        <input :disabled="timeframe!='week'" type="number" @input="updateMaterialCost()" min="0" max="9999" v-model.number="cost" @focus="$event.target.select()">
    </td>
</template>
<style scoped>
    .table-condensed td {
        padding: 0;
    }
    .currency::after{
        content: "€";
    }
    .curweek {
        font-weight: bold;
    }
    input{
        line-height: normal;
    }
    .table-data{
        /*text-align: right;*/
    }
    .curweek {
        border-left: 3px solid black;
    }
</style>

<script>

import { mapGetters, mapActions, mapState } from 'vuex';

export default {
  name: 'ProjectMaterialCostCell',
  components: {
  },
  props: {
    materialId: '',
    date: '',
    timeframe: '',
  },
  data: function () {
    return {
      cost: 0,
    };
  },
  computed: {
    ...mapGetters('JiraProjects', ['projects', 'projectCategories']),
    ...mapGetters('Worklogs', ['actualDate', 'curweek']),
    ...mapGetters('ProjectMaterials', ['projectMaterialCostsByMaterialByYearweek', 'projectMaterialCostsByMaterialByMonth', 'projectMaterialCostsByMaterialByQuarter', 'projectMaterialCostsByMaterialByYear']),
    projectMaterialCostsByMaterialByDate() {
      switch (this.timeframe) {
        case 'week':
          return this.projectMaterialCostsByMaterialByYearweek;
          break;
        case 'month':
          return this.projectMaterialCostsByMaterialByMonth;
          break;
        case 'quarter':
          return this.projectMaterialCostsByMaterialByQuarter;
          break;
        case 'year':
          return this.projectMaterialCostsByMaterialByYear;
          break;
      }
    }
  },
  methods: {
    ...mapActions('ProjectMaterials', ['UPDATE_PROJECT_MATERIAL_COST', 'PUSH_ON_LOADED_CALLBACK']),
    updateMaterialCost() {
      this.UPDATE_PROJECT_MATERIAL_COST({
        materialId: this.materialId,
        date: this.date.string,
        cost: this.cost,
        uid: this._uid
      });
    },
    setInitialCost() {
      if (this.projectMaterialCostsByMaterialByDate[this.materialId] && this.projectMaterialCostsByMaterialByDate[this.materialId][this.date.index]) this.cost = this.projectMaterialCostsByMaterialByDate[this.materialId][this.date.index];
    }
  },
  mounted() {
  },
  created() {
    const _this = this;
    this.PUSH_ON_LOADED_CALLBACK(() => {
      _this.setInitialCost();
    });
  },
  mounted() {
    const _this = this;
    this.setInitialCost();
    EventBus.$on(`update-material-cost${this._uid}`, (data) => {
      _this.setInitialCost();
    });
  }
};

</script>
